export const ItemTypes = {
  PLAYER: "player"
};



// WEBPACK FOOTER //
// ./src/constants.jsx